import { Card, Switch, Form, InputNumber, Select, Typography } from "antd";

const { Text } = Typography;

export default function GeneralSection({ config, onChange }) {
  const update = (path, value) => {
    onChange({
      ...config,
      [path]: value
    });
  };

  const updateNested = (section, key, value) => {
    onChange({
      ...config,
      [section]: {
        ...config[section],
        [key]: value
      }
    });
  };

  return (
    <Card bordered={false}>
      <Form layout="vertical">

        {/* Enable */}
        <Form.Item label="Enable Reservation Experience">
          <Switch
            checked={config.enabled}
            onChange={(v) => update("enabled", v)}
          />
          <Text type="secondary" style={{ display: "block" }}>
            Turn off to temporarily stop online reservations.
          </Text>
        </Form.Item>

        {/* Booking Rules */}
        <Form.Item label="Slot Interval (minutes)">
          <InputNumber
            min={5}
            max={60}
            value={config.bookingRules.slotIntervalMins}
            onChange={(v) =>
              updateNested("bookingRules", "slotIntervalMins", v)
            }
          />
          <Text type="secondary">
            Time gap between reservation slots (e.g. 15 mins).
          </Text>
        </Form.Item>

        <Form.Item label="Default Reservation Duration (minutes)">
          <InputNumber
            min={30}
            max={300}
            value={config.bookingRules.defaultDurationMins}
            onChange={(v) =>
              updateNested("bookingRules", "defaultDurationMins", v)
            }
          />
          <Text type="secondary">
            Used for table availability calculations.
          </Text>
        </Form.Item>

        <Form.Item label="Guest Limits">
          <InputNumber
            min={1}
            value={config.bookingRules.minGuests}
            onChange={(v) =>
              updateNested("bookingRules", "minGuests", v)
            }
          />{" "}
          to{" "}
          <InputNumber
            min={config.bookingRules.minGuests}
            value={config.bookingRules.maxGuests}
            onChange={(v) =>
              updateNested("bookingRules", "maxGuests", v)
            }
          />
          <Text type="secondary" style={{ display: "block" }}>
            Restrict party size for online reservations.
          </Text>
        </Form.Item>

      </Form>
    </Card>
  );
}
